import React from 'react';
import CRUD_productos from '../Firebase/CRUDS/CRUD_productos';


const Productos = () =>{
    return(
        <div>
            <div >
             
            <div id="listas">  
               
            </div>  
            <CRUD_productos/>
            </div>
        </div>
    )
}

export default Productos;